import { render, staticRenderFns } from "./ListItem.vue?vue&type=template&id=348fe8ba&scoped=true&"
import script from "./ListItem.vue?vue&type=script&lang=js&"
export * from "./ListItem.vue?vue&type=script&lang=js&"
import style0 from "./ListItem.vue?vue&type=style&index=0&id=348fe8ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348fe8ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('348fe8ba')) {
      api.createRecord('348fe8ba', component.options)
    } else {
      api.reload('348fe8ba', component.options)
    }
    module.hot.accept("./ListItem.vue?vue&type=template&id=348fe8ba&scoped=true&", function () {
      api.rerender('348fe8ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Goods/ListItem.vue"
export default component.exports